/* eslint-disable react/no-danger */
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { CloudinaryPicture } from '@bwoty-web/ui-kit';

import './buildingContent.scss';

const BuildingContent = ({ content, tabsExist }) => {
  if (!content || !content.parts) {
    return false;
  }

  const buildingViewClasses = classnames(
    { 'gw-building-view': tabsExist },
  );

  return (
    <div className={buildingViewClasses}>
      {content.intro && <div className="gw-building-view__intro"><p dangerouslySetInnerHTML={{ __html: content.intro }} /></div>}
      {content.picture && (
        <CloudinaryPicture
          img={content.picture}
          className="gw-building-view__image"
          sizes={[
            {
              width: 1024,
              breakpoint: 768,
            },
            {
              width: 768,
              breakpoint: 416,
            },
            {
              width: 415,
            },
          ]}
          alt={content.picture?.text}
          lazy
          retina
        />
      )}
      {(content.parts || []).map((part) => (
        <div key={part.name} className="gw-building-view__part">
          {part.name && <h3>{part.name}</h3>}
          {part.text && <p dangerouslySetInnerHTML={{ __html: part.text }} />}
        </div>
      ))}
    </div>
  );
};

BuildingContent.propTypes = {
  content: PropTypes.shape({
    heading: PropTypes.string,
    intro: PropTypes.string,
    __typename: PropTypes.string,
    picture: PropTypes.shape({
      fallback: PropTypes.shape({}),
      sources: PropTypes.arrayOf(PropTypes.shape({})),
      text: PropTypes.string,
    }),
    parts: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string,
      text: PropTypes.string,
    })),
  }).isRequired,
  tabsExist: PropTypes.bool.isRequired,
};

export default BuildingContent;
